<template>
<div>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>{{ $t("navigations.approve forms") }}</h2>
    </div>
  </div>
  <div class="wrapper wrapper-content">
    <div class="ibox-content mb-1 px-3 py-2">
      <div class="form-group row mb-1">
        <div class="d-flex flex-column flex-lg-row my-2 my-lg-0 mb-lg-0">
          <div class="form-group mb-lg-0 w-100 px-1 pl-lg-0">
            <label class="mb-0">{{ $t("navigations.form name") }}</label>
            <input type="text" class="form-control" v-model="templateName" />
          </div>
          <div class="form-group mb-lg-0 w-100 px-1 pl-lg-0">
            <label class="mb-0"> {{ $t("navigations.status") }}</label>
            <select class="form-select my-md-2 my-lg-0" v-model="Status">
              <option  selected value="">{{ $t("navigations.all") }}</option>
              <option value="Approved">{{ $t("navigations.approved") }}</option>
              <option value="Rejected">{{ $t("navigations.rejected") }}</option>
              <option value="Assigned">{{ $t("navigations.assigned") }}</option>
            </select>
          </div>
          <span
            type="button"
            @click.prevent="onSearchButtonClicked()"
            class="
              col-sm-12 col-lg-2
              save_btn
              my-1 my-lg-0
              mx-lg-1
              align-self-end
            "
          >
            {{ $t("navigations.search") }}
          </span>
        </div>
      </div>
    </div>
    <div class="ibox-body">
      <div class="ibox-title style_2 d-flex justify-content-between">
        <h5 class="mt-1">{{ $t("navigations.approve forms") }}</h5>
      </div>
      <div class="ibox-content">
        <div class="text-center" v-if="showLoading === true">
          <img
            src="../../assets/img/loading.gif"
            width="15"
            class=""
            alt="Waiting for login"
          />
          <div>
            {{ $t("navigations.please wait while the list is being loaded") }}
          </div>
        </div>      
        <template  v-else>
          <div class="text-center" v-if="formlist.length==0">
            {{ $t('navigations.no data available') }}
          </div>
          <div class="table-responsive" v-else>
            <table class="table table-striped table-bordered dataTables">
              <thead>
                <tr>
                  <th class="sort_block"
                    @click="SortSelected('templatename', 1)"
                    id="1">
                     <div class="d-flex flex-row justify-content-between">
                      {{ $t("navigations.form name") }}
                       <span>
                          <i class="fa fa-long-arrow-up"></i>
                          <i class="fa fa-long-arrow-down"></i>
                        </span>
                     </div></th>
                  <th  class="sort_block"
                    @click="SortSelected('language', 2)"
                    id="2" >
                    <div class="d-flex flex-row justify-content-between">
                      {{ $t("navigations.language") }}
                       <span>
                          <i class="fa fa-long-arrow-up"></i>
                          <i class="fa fa-long-arrow-down"></i>
                        </span>
                    </div></th>
                  <th class="sort_block"
                    @click="SortSelected('languagecode', 3)"
                    id="3" >
                    <div class="d-flex flex-row justify-content-between">
                      {{ $t("navigations.language code") }}
                       <span>
                          <i class="fa fa-long-arrow-up"></i>
                          <i class="fa fa-long-arrow-down"></i>
                        </span>
                    </div></th>
                  <th class="sort_block"
                    @click="SortSelected('version', 4)"
                    id="4" >
                    <div class="d-flex flex-row justify-content-between">
                      {{ $t("navigations.version") }}
                       <span>
                          <i class="fa fa-long-arrow-up"></i>
                          <i class="fa fa-long-arrow-down"></i>
                        </span>
                    </div></th>
                  <th class="sort_block"
                    @click="SortSelected('status', 5)"
                    id="5" >
                    <div class="d-flex flex-row justify-content-between">
                      {{ $t("navigations.status") }}
                       <span>
                          <i class="fa fa-long-arrow-up"></i>
                          <i class="fa fa-long-arrow-down"></i>
                        </span> 
                    </div></th>
                  <th class="sort_block"
                    @click="SortSelected('assigneddate', 6)"
                    id="6" >
                    <div class="d-flex flex-row justify-content-between">
                      {{ $t("navigations.assigned date") }}
                       <span>
                          <i class="fa fa-long-arrow-up"></i>
                          <i class="fa fa-long-arrow-down"></i>
                        </span>
                    </div></th>
                  <th class="text-center">{{ $t("navigations.view") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="form in formlist" :key="form.id">
                  <td>{{ form.template.templateName }}</td>
                  <td>{{ form.template.language }}</td>
                  <td>{{ form.template.languageCode }}</td>
                  <td>{{ form.template.version }}</td>
                  <td v-if="form.approval.length <= 1">
                    <span v-for="(approval, index) in form.approval" :key="index">
                      {{ approval.status }}
                    </span>
                  </td>
                  <td v-else>
                    {{ form.approval[form.approval.length - 1].status }}
                  </td>

                  <td>{{ filter(form.template.CreatedAt) }}</td>
                  <td class="text-center" v-if="form.approval.length <= 1">
                    <span v-for="(approval, index) in form.approval" :key="index">
                      <i
                        class="fa fa-eye editicon"
                        @click="
                          viewtemplate(
                            form.template.id,
                            form.id,
                            approval.status,
                            form.approval.comments
                          )
                        "
                      >
                      </i>
                    </span>
                  </td>
                  <td class="text-center" v-else>
                    <i
                      class="fa fa-eye editicon"
                      @click="
                        viewtemplate(
                          form.template.id,
                          form.id,
                          form.approval[form.approval.length - 1].status,
                          form.approval[form.approval.length - 1].comments
                        )
                      "
                    ></i>
                  </td>
                </tr>
              </tbody>
            </table>           
          </div>
           <!------ pagination -------->
            <div class="row mx-0" v-if="formlist.length!=0">
              <div class="col-lg-12 mx-0 px-0">
                <div
                  class="
                    dataTables_paginate
                    paging_simple_numbers
                    pagination
                    float-right
                  "
                >
                  <div class="col-lg-12 d-flex justify-content-lg-end px-0">
                    <v-pagination
                      v-model="currentPage"
                      :pages="totalItems"
                      :range-size="1"
                      active-color="#618bd7"
                      @update:modelValue="loadPage"
                    />
                  </div>
                </div>
              </div>
            </div>
            <!---Pagination ends-->
        </template>
      </div>
    </div>
  </div>
</div>
</template>
<script src="./digital_form.js">
</script>